export default __webpack_public_path__ + "static/media/medium.b5c13839.svg";